import { ChatSession } from '@klant/conversational-connector/klant-conversational-connector.model';
import { ChatNotificationsModel } from '@klant/conversational-connector/models/ChatNotifications.model';
import { ChatSessionMapper } from '@klant/conversational-connector/mappers/chat-session-mapper/chat-session.mapper';
import { ConversationalChatMapper } from '@klant/conversational-connector/mappers/conversational-chat-mapper/conversational-chat.mapper';

import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConversationalChatResource, ChatNotificaties, AccessToken } from '@ap/interface-apic-conversational-chat';

@Injectable({ providedIn: 'root' })
export class ConversationalConnectorService {
    private readonly conversationalChatResource = inject(ConversationalChatResource);

    public generateToken(): Observable<ChatSession> {
        return this.conversationalChatResource
            .generateToken()
            .pipe(map((accessToken: AccessToken) => ChatSessionMapper.mapAccessTokenToChatSession(accessToken)));
    }

    public deleteChatNotifications(): Observable<void> {
        return this.conversationalChatResource.deleteChatNotifications();
    }

    public getChatNotifications(): Observable<ChatNotificationsModel> {
        return this.conversationalChatResource.getChatNotifications().pipe(
            map((chatNotificaties: ChatNotificaties) => {
                return ConversationalChatMapper.mapChatNotificatiesToChatNotificationsModel(chatNotificaties);
            })
        );
    }
}
